import { render } from "./LoginCard.vue?vue&type=template&id=7f2e3d36&scoped=true&ts=true"
import script from "./LoginCard.vue?vue&type=script&lang=ts"
export * from "./LoginCard.vue?vue&type=script&lang=ts"

import "./LoginCard.vue?vue&type=style&index=0&id=7f2e3d36&lang=scss&scoped=true"

import exportComponent from "/jenkins-tmp/workspace/Recruiting-PP6/Oidcserver/development@2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2e3d36"]])

export default __exports__